import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { Breadcrumb } from "sprint-common-web";

import { adminAirlinesRoute, adminRoutes } from "../../AdminRoutes";
import { SystemPlatformListingContext } from "./context/SystemPlatformListingContext";

export const SystemPlatformListingBreadcrumb: React.FunctionComponent = () => {
    const history = useHistory();
    const { airlineName, isLoading } = useContext(SystemPlatformListingContext);

    const goToAirlinesListing = () => {
        history.push(adminAirlinesRoute.path);
    };

    return (
        <Breadcrumb
            items={[
                ...adminRoutes.baseRouteNames.map((name: string) => {
                    return { key: name, text: name };
                }),
                {
                    key: "airlines",
                    text: "Airlines",
                    onClick: goToAirlinesListing
                },
                {
                    key: "airlineName",
                    text: airlineName
                }
            ]}
            isLoading={isLoading}
        />
    );
};
